import { queryOptions } from "@tanstack/react-query";
import { catalogApi } from "./api.ts";

// Ключи справочника начинаются с "catalog": после правки поиск и карточки
// сбрасываются разом.
export const CATALOG = ["catalog"] as const;

export const categoriesQuery = queryOptions({ queryKey: [...CATALOG, "categories"], queryFn: catalogApi.categories, staleTime: 5 * 60_000 });

export const templateQuery = (id: string) =>
  queryOptions({ queryKey: [...CATALOG, "template", id], queryFn: () => catalogApi.template(id), retry: false });

export const partnersQuery = (q: string) => queryOptions({ queryKey: [...CATALOG, "partners", q], queryFn: () => catalogApi.partners(q) });

export const partnerQuery = (id: string) =>
  queryOptions({ queryKey: [...CATALOG, "partner", id], queryFn: () => catalogApi.partner(id), retry: false });
